import PropTypes from 'prop-types'
import React from 'react'
import { Dialog } from '@leverege/ui-elements'
import style from './style.css'

const { factory } = require( './WhereFactory' )

class WhereModal extends React.Component {
  static propTypes = {
    onWhere : PropTypes.func.isRequired,
    where : PropTypes.arrayOf( PropTypes.array ),
    isOpen : PropTypes.bool,
    close : PropTypes.func,
    newWhere : PropTypes.array.isRequired,
    whereSuggestions : PropTypes.array
  }

  static defaultProps = {
    isOpen : false,
    where : null,
    close : () => {},
    whereSuggestions : []
  }

  render() {
    const { where, whereSuggestions, newWhere, onWhere, isOpen, close } = this.props

    const pathComponents = Array.isArray( where ) ? where.map( ( where, index ) => {
      return factory( where, { aliasSuggestions : whereSuggestions, key : typeof path === 'string' ? `${where}-${index}` : `${where[0]}-${index}`, index, onChange : onWhere } ) // <WhereEditor aliasSuggestions={whereSuggestions} key={typeof path === 'string' ? `${where}-${index}` : `${where[0]}-${index}`} where={where} index={index} onChange={onWhere} />
    } ) : []

    pathComponents.push( factory( newWhere, { aliasSuggestions : whereSuggestions, key : 'newWhere', index : -1, onChange : onWhere, create : true } ) ) // <WhereEditor aliasSuggestions={whereSuggestions} where={newWhere} key="newWhere" index={-1} onChange={onWhere} create /> )

    return (
      <Dialog.Message show={isOpen} onClose={close} title="Add and Remove Where Clauses">
        <div className={style.rootOperator}>and</div>
        {pathComponents}
      </Dialog.Message>
    )
  }
}

exports.WhereModal = WhereModal
